import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_STSTCL_SELC,
    SG_STSTCL_SELC_HSCODE,
} from "@/tz/go/egaz/osci/ststcl/lpco/service/OsciStstclSelcService";

export const OSCI0502002Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0141" }, { area: "comnCd", comnCd: "OSC0159" }, { area: "hsCd" }],
    });

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004", "auth_osci0019"],
    });
    const pgeTitle = "Statistics by HS Code"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    // 전체 조회용 기관(OGAZ0037)이면 OGA 선택 가능 !== ==!
    const isAllOga = auth.get("orgCd") === "OGAZ0037";

    const [srchPrdDvnCd, setSrchPrdDvnCd] = useState("Y");

    const [ststclList, setStstclList] = useState(comnUtils.getGridData([]));

    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);

    // ORG LPCO LIST
    const [orgLpcoList, setOrgLpcoList] = useState([]);

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Statistics by Search Form !== HSCODE 통계 검색 Form ==!
        ststclSelcSrch: useForm({
            defaultSchema: SF_SCHEMA_STSTCL_SELC,
            defaultValues: {
                srchPrdDvnCd: srchPrdDvnCd,
                // 전체 조회용 기관(OGAZ0037)은 OGA를 공백으로 두어 전체 조회 !== ==!
                orgCd: isAllOga ? "" : auth.get("orgCd"),
                orgNm: isAllOga ? "" : auth.get("orgNm"),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Item Tab HS Code !== Item Tab HS Code 등록 ==!
        ststclList: useGrid({
            defaultSchema: SG_STSTCL_SELC_HSCODE,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getStstclHsCdList: useFetch({
            api: (page = grid.ststclList.page) => {
                return APIS.getStstclHsCdList(form.ststclSelcSrch.getValues(), page, grid.ststclList.size);
            },
            onSuccess: (data: any) => {
                setStore(pgeUid, {
                    form: form.ststclSelcSrch.getValues(),
                    page: grid.ststclList.page,
                    size: grid.ststclList.size,
                });

                setStstclList(comnUtils.getGridData(data?.ststclList?.content || []));
                if (srchPrdDvnCd == "Y") {
                    grid.ststclList.setShow("column", "ststclYy", true);
                    grid.ststclList.setShow("column", "ststclQrt", false);
                    grid.ststclList.setShow("column", "ststclMm", false);
                } else if (srchPrdDvnCd == "Q") {
                    grid.ststclList.setShow("column", "ststclYy", true);
                    grid.ststclList.setShow("column", "ststclQrt", true);
                    grid.ststclList.setShow("column", "ststclMm", false);
                } else if (srchPrdDvnCd == "M") {
                    grid.ststclList.setShow("column", "ststclYy", true);
                    grid.ststclList.setShow("column", "ststclQrt", false);
                    grid.ststclList.setShow("column", "ststclMm", true);
                } else if (srchPrdDvnCd == "C") {
                    grid.ststclList.setShow("column", "ststclYy", false);
                    grid.ststclList.setShow("column", "ststclQrt", false);
                    grid.ststclList.setShow("column", "ststclMm", false);
                }
            },
            onError: () => {},
            showToast: false,
        }),
        getOrgLpcoList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(data);
            },
            onSuccess: (data) => {
                console.log("getOrgLpcoList onSuccess ", data);
                setOrgLpcoList(data || []);
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getStstclHsCdList: () => {
            form.ststclSelcSrch.handleSubmit(
                (data) => {
                    // Check before and after the date !== 날짜 앞뒤 체크 ==!
                    let startDt = "";
                    let endDt = "";
                    let focusName = "";
                    if (srchPrdDvnCd == "Y") {
                        startDt = form.ststclSelcSrch.getValue("srchStrYear");
                        endDt = form.ststclSelcSrch.getValue("srchEndYear");

                        focusName = "srchEndYear";
                    } else if (srchPrdDvnCd == "Q") {
                        startDt =
                            form.ststclSelcSrch.getValue("srchStrQrtYy") + form.ststclSelcSrch.getValue("srchStrQrt");
                        endDt =
                            form.ststclSelcSrch.getValue("srchEndQrtYy") + form.ststclSelcSrch.getValue("srchEndQrt");

                        focusName = "srchEndQrtYy";
                    } else if (srchPrdDvnCd == "M") {
                        startDt =
                            form.ststclSelcSrch.getValue("srchStrYmYy") + form.ststclSelcSrch.getValue("srchStrYmMm");
                        endDt =
                            form.ststclSelcSrch.getValue("srchEndYmYy") + form.ststclSelcSrch.getValue("srchEndYmMm");

                        focusName = "srchEndYmYy";
                    } else if (srchPrdDvnCd == "C") {
                        startDt = form.ststclSelcSrch.getValue("srchCustomStrtDt");
                        endDt = form.ststclSelcSrch.getValue("srchCustomEndDt");

                        focusName = "srchCustomEndDt";
                    }
                    if (endDt < startDt) {
                        modal.openModal({
                            content: "msg.osc.00081",
                        });
                        form.ststclSelcSrch.setFocus(focusName);
                        return false;
                    }

                    grid.ststclList.setPage(0);
                    fetch.getStstclHsCdList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        refreshOrgCdList: async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        refreshOrgLpcoList: async (usrOrgCd: any) => {
            if (usrOrgCd) setOrgLpcoList((await lpcoUtils.getOrgLpcoList(usrOrgCd)) || []);
            else setOrgLpcoList([]);
        },
        setInit: async () => {
            // !== 기관 목록 ==!
            handler.refreshOrgCdList();

            // 기관 LPCO SELECT 목록
            await fetch.getOrgLpcoList.fetch(auth.get("orgCd"));

            //handler.getStstclList();
        },
    };

    useEffect(() => {
        console.log("useEffect ==========================");
        lpcoUtils.setSrchFormFromStore(form.ststclSelcSrch, pgeStore);
        setSrchPrdDvnCd(form.ststclSelcSrch.getValue("setSrchPrdDvnCd") || "Y");
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.ststclSelcSrch.schema.orgCd} options={orgCdList} edit={isAllOga} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.ststclSelcSrch.schema.srchHsCd} />
                            <Group.Control {...form.ststclSelcSrch.schema.srchRegmTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.ststclSelcSrch.schema.srchPrdDvnCd}
                                onChange={(v: any) => {
                                    console.log("v ", v);
                                    setSrchPrdDvnCd(v);
                                }}
                            />
                        </Group.Row>

                        {srchPrdDvnCd == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.ststclSelcSrch.schema.srchStrYear} />
                                <Group.Control {...form.ststclSelcSrch.schema.srchEndYear} />
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "Q" && (
                            <Group.Row>
                                <Group.Label label={"L_STRT_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.ststclSelcSrch.schema.srchStrQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.ststclSelcSrch.schema.srchStrQrt} />
                                </Group.Col>
                                <Group.Label label={"L_END_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.ststclSelcSrch.schema.srchEndQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.ststclSelcSrch.schema.srchEndQrt} />
                                </Group.Col>
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "M" && (
                            <Group.Row>
                                <Group.Label label={"L_STRT_YM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.ststclSelcSrch.schema.srchStrYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.ststclSelcSrch.schema.srchStrYmMm} />
                                </Group.Col>
                                <Group.Label label={"L_END_YM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.ststclSelcSrch.schema.srchEndYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.ststclSelcSrch.schema.srchEndYmMm} />
                                </Group.Col>
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "C" && (
                            <Group.Row>
                                <Group.Control {...form.ststclSelcSrch.schema.srchCustomRnge} />
                            </Group.Row>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.ststclSelcSrch.reset();
                                    // 조회 기간 구분은 화면 상태로 하위 입력을 제어하므로 함께 초기화한다.
                                    setSrchPrdDvnCd("Y");
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getStstclHsCdList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={async () => {
                                    const bResult = await form.ststclSelcSrch.validate();
                                    if (bResult) {
                                        // excel download
                                        lpcoUtils.saveExcelDownload(
                                            BASE.api + "/hs-cd/excel-down",
                                            form.ststclSelcSrch.getValues(),
                                        );
                                    }
                                }}
                            />
                        </Layout.Left>
                    </Layout>

                    <Group.Section>
                        <Grid {...grid.ststclList.grid} data={ststclList} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
